module.exports = __webpack_public_path__ + "static/media/BrightPoint_4C_white.2b6fefaa.svg";